import React, { useState, useRef } from 'react';
import { Box, Grid, Theme, useTheme } from '@quillbot/design-system';
import { makeStyles } from '@mui/styles';
import { useSelector } from 'react-redux';
import { RootState } from '@Common/models/redux/store';
import Carousel from 'nuka-carousel';
import { url } from 'inspector';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    backgroundColor: theme.specialColors.CHECKOUT_PAGE_BG,
    padding: '64px 0',
    [theme.breakpoints.down('md')]: {
      padding: '40px 0',
    },
  },
  pageTitle: {
    fontSize: 24,
    fontWeight: 400,
    margin: 0,
    marginBottom: 40,
    textAlign: 'center',
  },
  imageSlider: {
    // pointerEvents: 'none',
  },
  imagesMarquee: {
    position: 'relative',
    maxWidth: '100%',
    height: '65px',
    overflow: 'hidden',
  },
  track: {
    position: 'absolute',
    whiteSpace: 'nowrap',
    willChange: 'transform',
    animation: '$marquee 100s linear infinite',
    '&:hover': {
      'animation-play-state': 'paused',
    },
  },
  '@keyframes marquee': {
    '0%': {
      transform: 'translateX(0)',
    },
    '100%': {
      transform: 'translateX(-50%)',
    },
  },
  innerTrack: {
    // display: 'flex',
  },
  imageItem: {
    display: 'inline-block',
    height: 64,
    backgroundSize: 'contain',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    cursor: 'pointer',
  },
  univeristyBox: {
    display: 'inline-flex',
    alignItems: 'center',
    margin: '0 54px',
  },
  universityName: {
    fontSize: '20px',
    fontWeight: 600,
    marginLeft: '16px',
    maxWidth: '160px',
    whiteSpace: 'pre-wrap',
  },
}));

export default function Universities() {
  const classes = useStyles();
  const theme = useTheme();

  const images = [
    {
      name: 'Cambridge University',
      imgUrl: `./images/theme/${theme.palette.mode}/studentResources/cambridge-university.png`,
    },
    {
      name: 'Illinois University',
      imgUrl: `./images/theme/${theme.palette.mode}/studentResources/illinois-university.png`,
    },
    {
      name: 'University of Southern California',
      imgUrl: `./images/theme/${theme.palette.mode}/studentResources/usc.png`,
    },
    {
      name: 'Mississippi University',
      imgUrl: `./images/theme/${theme.palette.mode}/studentResources/mississippi-university.png`,
    },
    {
      name: 'Iowa University',
      imgUrl: `./images/theme/${theme.palette.mode}/studentResources/iowa-university.png`,
    },
    {
      name: 'IIT Delhi',
      imgUrl: `./images/theme/${theme.palette.mode}/studentResources/iit-d.png`,
    },
    {
      name: 'IIM Bangalore',
      imgUrl: `./images/theme/${theme.palette.mode}/studentResources/iim-b.png`,
      showName: true,
    },
    {
      name: 'IIT Bombay',
      imgUrl: `./images/theme/${theme.palette.mode}/studentResources/iit-bombay.png`,
    },
    {
      name: 'IIM Kozhikode',
      imgUrl: `./images/theme/${theme.palette.mode}/studentResources/iim-k.png`,
    },
    {
      name: 'IIM Indore',
      imgUrl: `./images/theme/${theme.palette.mode}/studentResources/iim-i.png`,
    },
    {
      name: 'IIIT Lucknow',
      imgUrl: `./images/theme/${theme.palette.mode}/studentResources/iiit-l.png`,
    },
    {
      name: 'IIT Varanasi',
      imgUrl: `./images/theme/${theme.palette.mode}/studentResources/iit-varanasi.png`,
      showName: true,
    },
    {
      name: 'IIM Vishakapatnam',
      imgUrl: `./images/theme/${theme.palette.mode}/studentResources/iim-v.png`,
    },
    {
      name: 'Jaipuria',
      imgUrl: `./images/theme/${theme.palette.mode}/studentResources/jaipuria.png`,
    },
    {
      name: 'IIM Bodhgaya',
      imgUrl: `./images/theme/${theme.palette.mode}/studentResources/iim-bodh.png`,
    },
    {
      name: 'Medi-Caps University',
      imgUrl: `./images/theme/${theme.palette.mode}/studentResources/medicaps.png`,
    },
    {
      name: 'GLA',
      imgUrl: `./images/theme/${theme.palette.mode}/studentResources/gla.png`,
    },
    {
      name: 'Surrey University',
      imgUrl: `./images/theme/${theme.palette.mode}/studentResources/surrey-university.png`,
    },
    {
      name: 'ICEE',
      imgUrl: `./images/theme/${theme.palette.mode}/studentResources/icee.png`,
    },
    {
      name: 'MTC',
      imgUrl: `./images/theme/${theme.palette.mode}/studentResources/mtc.png`,
    },
    {
      name: 'Chiba University',
      imgUrl: `./images/theme/${theme.palette.mode}/studentResources/chiba-university.png`,
    },
    {
      name: 'TKM College of Engineering',
      imgUrl: `./images/theme/${theme.palette.mode}/studentResources/tkm-college.png`,
      showName: true,
    },
    {
      name: "Tula's Institute Dehradun",
      imgUrl: `./images/theme/${theme.palette.mode}/studentResources/tulas.png`,
      showName: true,
    },
    {
      name: 'Sacred Heart College',
      imgUrl: `./images/theme/${theme.palette.mode}/studentResources/sacred-heart.png`,
      showName: true,
    },
    {
      name: 'Deccan College',
      imgUrl: `./images/theme/${theme.palette.mode}/studentResources/deccan.png`,
    },
    {
      name: 'SGSITS Indore',
      imgUrl: `./images/theme/${theme.palette.mode}/studentResources/sgsits.png`,
      showName: true,
    },
    {
      name: 'SCSIT DAVV',
      imgUrl: `./images/theme/${theme.palette.mode}/studentResources/scsit-davv.png`,
      showName: true,
    },
    {
      name: 'SRM Institute of Science & Technology',
      imgUrl: `./images/theme/${theme.palette.mode}/studentResources/srm.png`,
    },
    {
      name: 'British University in Dubai',
      imgUrl: `./images/theme/${theme.palette.mode}/studentResources/british-dubai.png`,
    },
    {
      name: 'BITS Pilani Dubai',
      imgUrl: `./images/theme/${theme.palette.mode}/studentResources/bits-dubai.png`,
    },
    {
      name: 'SLIET',
      imgUrl: `./images/theme/${theme.palette.mode}/studentResources/sliet.png`,
      showName: true,
    },
    {
      name: 'IIT Bhubaneshwar',
      imgUrl: `./images/theme/${theme.palette.mode}/studentResources/iit-bhu.png`,
      showName: true,
    },
    {
      name: 'SCMS School of Engineering',
      imgUrl: `./images/theme/${theme.palette.mode}/studentResources/scms.png`,
    },
    {
      name: 'SPA Bhopal',
      imgUrl: `./images/theme/${theme.palette.mode}/studentResources/spa-bhopal.png`,
      showName: true,
    },
    {
      name: 'Shyam Lal College Delhi',
      imgUrl: `./images/theme/${theme.palette.mode}/studentResources/shyam-lal.png`,
      showName: true,
    },
    {
      name: 'NIT Hamirpur',
      imgUrl: `./images/theme/${theme.palette.mode}/studentResources/niit-hamirpur.png`,
      showName: true,
    },
    {
      name: 'IIM Ahmedabad',
      imgUrl: `./images/theme/${theme.palette.mode}/studentResources/iim-a.png`,
      showName: true,
    },
    {
      name: 'IIM Udaipur',
      imgUrl: `./images/theme/${theme.palette.mode}/studentResources/iim-u.png`,
      showName: true,
    },
    {
      name: 'IIM Amritsar',
      imgUrl: `./images/theme/${theme.palette.mode}/studentResources/iim-amritsar.png`,
      showName: true,
    },
    {
      name: 'IIM Lucknow',
      imgUrl: `./images/theme/${theme.palette.mode}/studentResources/iim-lucknow.png`,
      showName: true,
    },
    {
      name: 'SVNIT Surat',
      imgUrl: `./images/theme/${theme.palette.mode}/studentResources/svnit.png`,
      showName: true,
    },
    {
      name: 'Wellingkar Institute',
      imgUrl: `./images/theme/${theme.palette.mode}/studentResources/we-school.png`,
    },
  ];

  return (
    <>
      <Grid container className={classes.root}>
        <Grid item xs={12}>
          <h2 className={classes.pageTitle}>QuillBot is trusted by top-tier universities!</h2>
        </Grid>
        <Grid item xs={12}>
          <div className={classes.imagesMarquee}>
            <div className={classes.track}>
              <div className={classes.innerTrack}>
                {[1, 2, 3, 4].map(() =>
                  // Looped for the purpose of marquee animation
                  images.map((image) => (
                    <Box key={image.name} className={classes.univeristyBox}>
                      <img className={classes.imageItem} src={image.imgUrl} alt={image.name} />
                      {image.showName && <div className={classes.universityName}>{image.name}</div>}
                    </Box>
                  ))
                )}
              </div>
            </div>
          </div>
        </Grid>
      </Grid>
    </>
  );
}
